<template>
  <div class="RestPasswordVue-wrap">
    <div class="RestPasswordVue-box">
      <h1>忘记密码</h1>
      <div class="input-wrap" v-if="!yzmFlag">
        <span>登录账号</span>
        <div class="input-box">
          <i class="iconfont icon-yonghuming"></i>
          <input
            type="text"
            v-model="username"
            placeholder="请输入邮箱"
            @keyup.enter="goLogin"
          />
        </div>
      </div>
      <div class="input-wrap" v-if="yzmFlag">
        <span>登录账号</span>
        <div class="input-box">
          <i class="iconfont icon-yonghuming"></i>
          <input
            type="text"
            v-model="username"
            disabled
            
          />
        </div>
      </div>
      <div class="input-wrap" v-if="yzmFlag">
        <span>邮箱验证码</span>
        <div class="input-box">
            <i class="iconfont icon-mima"></i>
          <input
            type="text"
            v-model="yzm"
            placeholder="验证码"
            @keyup.enter="goLogin"
              />
        </div>
      </div>
      <div class="input-wrap" v-if="yzmFlag">
        <span>登录密码</span>
        <div class="input-box">
          <i class="iconfont icon-mima"></i>
          <input
            type="password"
            v-model="password"
            placeholder="请输入密码"
            @keyup.enter="goLogin"
          />
        </div>
      </div>
      <div class="input-wrap" v-if="yzmFlag">
        <span>确认密码</span>
        <div class="input-box">
          <i class="iconfont icon-mima"></i>
          <input
            type="password"
            v-model="rePassword"
            placeholder="请再次密码"
            @keyup.enter="goLogin"
          />
        </div>
      </div>
      <div class="login-button" @click="goLogin">
        <span>{{ yzmFlag ? "重置密码" : "发送验证码" }}</span>
      </div>
      <span class="register-button" @click="openRegister">返回登录</span>
    </div>
  </div>
</template>
  
  <script>
import api from "@/api/login";
import CryptoJS from "crypto-js";
export default {
  name: "RestPasswordVue",
  data() {
    return {
      username: "",
      password: "",
      rePassword: "",
      code: "",
      uuid: "",
      yzmFlag: false,
      yzm: ''
    };
  },
  methods: {
  cryptoJSPassword(password) { 
            const SECRET_KEY = "0123456789abcdef0123456789abcdef"; // 32字节(256位)密钥
            const IV = "abcdefghijklmnop"; // 16字节IV
            const key = CryptoJS.enc.Utf8.parse(SECRET_KEY);
            const iv = CryptoJS.enc.Utf8.parse(IV);
            const encrypted = CryptoJS.AES.encrypt(
                password,
                key,
                { 
                    iv: iv,
                    mode: CryptoJS.mode.CBC,
                    padding: CryptoJS.pad.Pkcs7
                }
            );
            return encrypted.toString()
        },
    getYzm() {
        
    },
    openRegister() {
      this.$emit("closeRestPassword");
    },
    goLogin() {
      if(this.yzmFlag) {
        if(!this.password) {
            this.$message({
                message: '请输入密码',
                type: 'warning'
            })
            return;
        }
        if(!this.rePassword) {
            this.$message({
                message: '请再次输入密码',
                type: 'warning'
            })
            return;
        }
        if(this.password !== this.rePassword) {
            this.$message({
                message: '两次密码不一致',
                type: 'warning'
            })
            return;
        }
        if(!this.yzm) {
            this.$message({
                message: '请输入验证码',
                type: 'warning'
            })
            return;
        }
        api.doRestPassword({
            code: this.yzm,
            email: this.username,
            password: this.cryptoJSPassword(this.password)
        }).then(res=> {
            if(res.code === 0) {
                this.$message({
                    message: '密码修改成功',
                    type: 'success'
                })
                this.$emit('closeRestPassword')
            } else {
                this.$message({
                    message: res.msg,
                    type: 'error'
                })
            }
        })
      } else {
        if(!this.username) {
            this.$message({
                message: '请输入邮箱',
                type: 'warning'
            })
            return;
        }
        api.getRegisterCodeToRestPassword({
            email: this.username
        }).then(res=> {
            if(res.code === 0) {
                this.$message({
                    message: '验证码已发送，请注意查收',
                    type: 'success'
                })
                this.yzmFlag = true;
            } else {
                this.$message({
                    message: res.msg,
                    type: 'error'
                })
            }
        })
      }
    },
  },
  created() {},
};
</script>
  
  <style lang="scss" scoped>
.RestPasswordVue-wrap {
  position: fixed;
  top: 50%;
  right: 30px;
  transform: translateY(-50%);
  width: 500px;
  padding: 70px 45px;
  background: #fff;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.4);
  border-radius: 8px;
  color: rgba(16, 16, 16, 1);
  font-family: "Roboto";
  z-index: 9999;
  .RestPasswordVue-box {
    h1 {
      margin-bottom: 50px;
    }
    .input-wrap {
      margin-top: 20px;

      span {
        font-size: 16px;
        color: #999;
      }

      .input-box {
        margin-top: 10px;
        position: relative;

        input {
          width: 100%;
          font-size: 16px;
          padding: 10px 40px;
          border: none;
          outline: none;
          background: #f5f5f5;
          border-radius: 5px;
        }

        i {
          color: #101010;
          position: absolute;
          top: 50%;
          left: 10px;
          transform: translateY(-50%);
        }
      }

      .input-box-2 {
        margin-top: 10px;
        display: flex;
        align-items: center;
        img {
          cursor: pointer;
        }
        span {
          display: inline-block;
          flex: 2;
          text-align: center;
          &:first-of-type {
            flex: 1;
          }
          &:last-of-type {
            color: #124fff;
            cursor: pointer;
          }
        }
        input {
          font-size: 16px;
          padding: 10px 20px;
          border: none;
          outline: none;
          background: #f5f5f5;
          border-radius: 5px;
          flex: 1;
          max-width: 250px;
        }
      }
    }

    .login-button {
      margin-top: 50px;

      span {
        display: block;
        padding: 15px 0;
        text-align: center;
        color: #fff;
        background: #00a8ff;
        border-radius: 5px;
        cursor: pointer;
      }
    }

    .register-button {
      display: inline-block;
      margin-right: 30px;
      margin-top: 30px;
      color: #00a8ff;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>